import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/Button';
import config from '../../config';
import { configItemsSubscription } from './settings/utils/payment';
import { ScrollArea } from '../../components/ScrollArea';

export function NotificationBySubscription({ className = '', count, resetCount, minCount = 20, force = false }) {
  const navigation = useNavigate();

  if (count < minCount && !force) return false;

  return (
    <div className={`relative z-50 bg-[#043939] flex-1 flex flex-col h-full p-4 rounded-[16px] ${className}`}>
      <button className="absolute top-[12px] right-[12px] p-4 rounded-full bg-white/10" onClick={resetCount}>
        <img src="/icons/close.svg" alt="close" />
      </button>
      <img className="w-[177px] mx-auto h-auto" src="/images/sub-card-notify.png" alt="Призыв купить подписку" />

      <div className="mb-2">
        <h2 className="text-[24px] font-bold text-white text-center w-full leading-[24px] mb-[3px]">
          Найди свою половинку <br /> в 2 раза быстрее
        </h2>
        <h3 className="text-[23px] font-bold text-[#A1F69E] flex items-center justify-center flex-nowrap whitespace-nowrap ">
          Всего за{' '}
          <span className="relative text-white opacity-80 inline-block ml-1">
            14
            <span className="inline-block text-[16px] -translate-y-[10px]">44</span>
            <span className="absolute inset-0 w-full h-[2px] bg-red-500 rotate-[12deg] top-1/2 left-0"></span>
          </span>{' '}
          <span className="inline-block ml-1">
            7<span className="inline-block text-[16px] -translate-y-[10px]">22</span>
          </span>
          <img src="/icons/BYN.svg" alt="BYN" className="ml-1 w-4 h-4 object-contain shrink-0" />
          <span className="ml-1">в неделю!</span>
        </h3>
      </div>

      <ScrollArea>
        {configItemsSubscription.map((i) => (
          <div key={i.id} className="flex items-center gap-2">
            <img src={i.iconUrl} alt="icon" className="size-[20px] shrink-0" />
            <p className="text-[16px] text-white">{i.title}</p>
          </div>
        ))}
      </ScrollArea>

      <div className="flex items-center justify-between gap-1 bg-[#006565] px-4 py-1 my-[15px] -mx-4">
        <div className="flex items-center justify-center">
          <img src="/icons/tg.svg" alt="tg" className="size-[27px]" />
          <img src="/icons/lock.svg" alt="lock" className="size-[27px]" />
        </div>

        <div>
          <div className="text-[14px] text-white flex items-center justify-center gap-1">
            <p>Оплата происходит в звёздах</p>
            <span className="font-bold">110</span>
            <img src="/icons/tg_star.png" alt="" className="w-4 h-4" />
          </div>
          <span className="text-[14px] font-bold text-white">Платежи защищены Telegram</span>
        </div>
      </div>
      <Button className="w-full" onClick={() => navigation(config.ROUTES.PREMIUM)}>
        Забрать скидку -50%
      </Button>
    </div>
  );
}
